<template>
  <section role="main" class="content-body">
    <header class="page-header">
      <h2>請假單審核</h2>
      <div class="right-wrapper">
        <ol class="breadcrumbs">
          <li>
            <a href="/">
              <i class="fa fa-home"></i>
            </a>
          </li>
          <li><span>助學金管理系統</span></li>
          <li><span>請假單審核</span></li>
        </ol>
      </div>
    </header>
    <div id="tabs-01" class="row">
      <div id="tabs-03" class="row">
        <div class="col-md-12">
          <section class="panel ">
            <header class="panel-heading">
              <div class="panel-actions">
                <a href="#" class="panel-action panel-action-toggle" data-panel-toggle></a>
              </div>
              <h2 class="panel-title">查詢條件</h2>
            </header>
            <div class="panel-body" align="right">
              <div align="left">
                <div class="col-md-4">姓名/學號：<input type="text" name="name" v-model="search.keyword"></div>
                <a href="javascript:;" @click.prevent="searchSubmit" class="btn-upload btn btn-primary" style="background-color:#337AB7; border-color:#2E6DA4;">查詢</a>
                <a href="javascript:;" @click.prevent="searchClear" class="btn-upload btn btn-primary" style="background-color:#666; border-color:#666;">清空</a>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
    <div id="tabs-02" class="row">
      <div id="tabs-04" class="row">
        <div class="col-md-12">
          <section class="panel">
            <div class="panel-body">
              <table ref="table" class="table table-no-more table-bordered table-striped mb-none">
                <thead>
                  <tr>
                    <th class="text-center" width="5%">序號</th>
                    <th class="text-center" width="15%">聘僱單位</th>
                    <th class="text-center" width="15%">班級</th>
                    <th class="text-center" width="10%">學號</th>
                    <th class="text-center" width="10%">學生姓名</th>
                    <th class="text-center" width="15%">請假期間</th>
                    <th class="text-center" width="20%">請假原因</th>
                    <th class="text-center" width="10%">審核狀態</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in list" :key="index">
                    <td data-title="序號" class="text-center">{{index + 1}}</td>
                    <td data-title="審核單位" class="text-left">{{item.deptName}}</td>
                    <td data-title="班級" class="text-left">{{item.dradeClass}}</td>
                    <td data-title="學號" class="text-center">{{item.studentId}}</td>
                    <td data-title="學生姓名" class="text-center">{{item.studentName}}</td>
                    <td data-title="請假日期" class="text-center" v-html="item.leaveTime"></td>
                    <td data-title="請假原因" class="text-left">{{item.leaveContent}}</td>
                    <td data-title="審核狀態" class="text-center">
                      <router-link v-if="item.isPass == null" :to="'/leave-audit/check/' + item.id" class="btn-upload btn s_btn_o">未審核</router-link>
                      <div v-else-if="item.isPass == true">審核通過</div>
                      <div v-else>審核不通過<div style="border: 1px solid #e0e0e0; margin-top: 3px;">{{item.notPassReason}}</div></div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      search: {
        keyword: null
      },
      list: []
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      if ($.fn.DataTable.isDataTable(this.$refs.table)) {
        $(this.$refs.table).DataTable().destroy();
      }
      this.$http
        .get("/api/workstudyLeaveAudit", { params: { keyword: this.search.keyword } })
        .then(a => {
          this.list = a.body;
          this.$nextTick(b => {
            $(this.$refs.table).DataTable({
              bFilter: false,
              bLengthChange: false,
              language: {
                info: "第 _PAGE_ 頁 / 總共 _PAGES_ 頁"
              },
              columnDefs: [
                {
                  targets: 0,
                  orderable: false,
                }
              ],
              order: [1, "desc"],
              columns: [
                { width: "7%" },
                { width: "14%" },
                { width: "15%" },
                { width: "10%" },
                { width: "10%" },
                { width: "14%" },
                { width: "20%" },
                { width: "10%" }
              ]
            });
          });
        });
    },
    searchClear() {
      this.search.keyword = null;
    },
    searchSubmit() {
      this.load();
    }
  }
};
</script>

<style>
</style>